import React, { useEffect, useState } from 'react';
import { Modal, Table, Button } from 'react-bootstrap';
import { turnoMap, UserByDistance } from '../../../../../service/types/types';
import { PrediosService } from '../../../../../service/predios.service';
import { PeopleFill, PlusCircle } from "react-bootstrap-icons";



type Props = {
  predioId: string;
};

export default function UsuariosCercanosModal({predioId}:Props) {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [users, setUsers] = useState<UserByDistance[]>([]);

    useEffect(() => {
    if(!show) return
    const fetchUsers = async () => {
        try {
        const data = await PrediosService.getClosestUsers(predioId);
        console.log("data", predioId, data)
        setUsers(data);
        } catch (error) {
        console.error('Error fetching users:', error);
        }
    };
    fetchUsers();
    }, [show]);
  return (
    <>
        <Button
            size="sm"
            className="me-2" 
            variant={"success"} 
            onClick={handleShow}>
             <PeopleFill className="me-1" /> Usuarios
        </Button>
        
        <Modal show={show} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton>
            <Modal.Title>Usuarios Cercanos</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Table striped bordered hover responsive>
            <thead>
                <tr>
                <th>RUT</th>
                <th>Nombre</th>
                <th>Teléfono</th>
                <th>Localidad</th>
                <th>turno</th>
                <th>Distancia (km)</th>
                </tr>
            </thead>
            <tbody>
                {users.map((u) => (
                <tr key={u.rut}>
                    <td>{u.rut}</td>
                    <td>{u.name}</td>
                    <td>{u.phone}</td>
                    <td>{turnoMap[u.turno] ?? u.turno}</td>
                    <td>{u.localidad}</td>
                    <td>{u.distance?.toFixed(2)}</td>
                </tr>
                ))}
            </tbody>
            </Table>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
            Cerrar
            </Button>
        </Modal.Footer>
        </Modal>
    </>
  );
}